<app-auth-container>
  <img class="autentique-logo smartphone" src="assets/logo-and-text-white.png" alt="" />
  <img class="autentique-logo tablet" src="assets/Autentique.svg" alt="" />
  <p class="auth__title">{{ 'profile.personalInfo' | translate }}</p>
  <p class="auth__descr auth__descr--small">{{ 'settings.personalInfoData' | translate }}</p>
  <form class="field__form" (ngSubmit)="update()" [formGroup]="form" novalidate>
    <div class="section">
      <p class="field__form-title">
        {{ 'profile.personalData' | translate }} <small [ngbTooltip]="personalData"><i class="fa-regular fa-circle-info"></i></small>
      </p>

      <label class="field__holder" [appFormControlWrap]="form.get('name')">
        <input type="text" class="field" formControlName="name" name="name" autocomplete="name" required appValidName appFullName appForbiddenNames />
        <span class="field__placeholder">{{ 'profile.fullName' | translate }}</span>
      </label>

      <ng-template #personalData>
        <div class="tooltip__title">{{ 'profile.personalData' | translate }}</div>
        <div class="tooltip__descr">{{ 'profile.personalDataTooltip' | translate }}</div>
      </ng-template>

      <div class="row">
        <div class="row__country" [appFormControlWrap]="form.get('country')">
          <app-select [menuMaxHeight]="230" placeholder="{{ 'profile.country' | translate }}" formControlName="country" [options]="countries" [required]="true"></app-select>
        </div>

        <div class="row__language" [appFormControlWrap]="form.get('language')">
          <app-select
            placeholder="{{ 'profile.language' | translate }}"
            formControlName="language"
            (click)="changeLanguage(form.get('language').value)"
            [options]="languages"
            [disableSearch]="true"
          ></app-select>
        </div>
      </div>
    </div>
    <div [class.d-none]="!isCompany" class="section">
      <p class="field__form-title" [class.d-none]="!isCompany">{{ 'profile.companyData' | translate }}</p>

      <label class="field__holder" [class.d-none]="!isCompany" [appFormControlWrap]="form.get('company')">
        <input type="text" class="field" formControlName="company" name="company" autocomplete="company" appValidCompanyName />
        <span class="field__placeholder">{{ 'profile.businessName' | translate }}</span>
      </label>

      @if (form.get('country').value === 'BR') {
        <label class="field__holder cnpj" [class.d-none]="!isCompany" [appFormControlWrap]="form.get('cnpj')">
          <input type="tel" class="field" formControlName="cnpj" name="cnpj" autocomplete="cnpj" mask="00.000.000/0000-00" />
          <span class="field__placeholder">{{ 'profile.cnpj' | translate }} ({{ 'profile.optional' | translate }})</span>
        </label>
      }
    </div>

    <div class="section">
      <p class="field__form-title">{{ 'profile.accType' | translate }}</p>

      <app-switch-tabs
        name="type"
        [options]="[
          [false, 'profile.naturalPerson' | translate],
          [true, 'profile.legalEntity' | translate]
        ]"
        [(ngModel)]="isCompany"
        [ngModelOptions]="{ standalone: true }"
      ></app-switch-tabs>
    </div>

    <div class="submit-holder">
      <button type="submit" class="submit btn-L btn-filled" [disabled]="isLoading || form.invalid">{{ 'button.forward' | translate }}</button>
      <button type="button" routerLink="/entrar" queryParamsHandling="preserve" class="back btn-L btn-text">{{ 'button.back' | translate }}</button>
    </div>
  </form>
</app-auth-container>
